export default "__VITE_ASSET__f7125a47__"